<template>
  <v-data-table
    id="documents_table__documentos__table"
    :headers="headers"
    :items="documents"
    :loading="loading"
    :options.sync="options"
    :server-items-length="documentsTotal"
    :loading-text="loadingText"
    :no-data-text="noDataText"
    :items-per-page="10"
    :show-current-page="true"
    :footer-props="{
      itemsPerPageOptions: [10, 50, 100, 500]
    }"
    :folder="folder"
    item-key="idDocumento" 
  >
    <template v-slot:item.icon="">
      <v-icon color="red">{{ icon.pdf }}</v-icon>
    </template>

    <template v-slot:item.idTipoDocumento="{ item }">
      <document-document-type v-model="item.idTipoDocumento" />
    </template>

    <template v-slot:item.idCarpeta="{ item }">
      <document-folder 
        v-model="item.idCarpeta"
        :width="documentsHeaders.find(e => e.value == 'idCarpeta').width"
      />
    </template>

    <template v-slot:item.descripcion="{ item }">
      <document-view 
        :value="item"
        :width="documentsHeaders.find(e => e.value == 'descripcion').width"
        type="cell"
      />
    </template>

    <template v-slot:item.firmantes="{ item }">
      <document-signers
        :idDocumento="item.idDocumento"
        :status="item.estatus"
        v-model="item.firmantes"
      />
    </template>

    <template v-slot:item.estatus="{ item }">
      <document-status :status="item.estatus" />
    </template>

    <template v-slot:item.idUsuario="{ item }">
      <owner-avatar dense v-model="item.idUsuario" />
    </template>

    <template v-slot:item.fechaSubidaS3="{ item }">
      <span class="registrado-label">{{
        $moment.tz(item.fechaSubidaS3, 'America/Mexico_City').format('DD-MMM-YYYY hh:mm a')
      }}</span>
    </template>

    <template v-slot:item.fechaExpiracion="{ item }">
      <span class="registrado-label">{{
        $moment.tz(item.fechaExpiracion, 'America/Mexico_City').format('DD-MMM-YYYY')
      }}</span>
    </template>
    
    <template v-slot:item.fechaConstancia="{ item }">
      <span
        v-if="item.fechaConstancia || item.estatus.descripcion === 'Firmado'"
        class="constancia-label"
        >{{
          $moment
            .tz(item.fechaConstancia, 'America/Mexico_City')
            .format('DD-MMM-YYYY')
        }}
      </span>
      <document-sign
        v-else
        :id="`documents_table__firmar__button` + item.clave"
        :idDocumento="item.idDocumento"
        :status="item.estatus"
        v-model="item.firmantes"
      />
    </template>

    <template v-slot:item.actions="{ item }">
      <div class="text-center">
        <document-actions-menu
          :id="'documents_table__acciones__button_' + item.clave"
          :value="item"
          @input="updateDocumentInStorage"
        />
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { mdiFileOutline } from '@mdi/js'
import { pushNotification, messageErrorResponse } from '@/store/helpers'

import DocumentSign from './DocumentSign'
import DocumentSigners from './commons/DocumentSigners'
import DocumentActionsMenu from './commons/DocumentActionsMenu'
import DocumentStatus from './commons/DocumentStatus'
import OwnerAvatar from './commons/OwnerAvatar'
import DocumentDocumentType from './commons/DocumentDocumentType'
import DocumentFolder from './commons/DocumentFolder'
import DocumentView from './DocumentView'

import { documentTypeStoreActions } from '../../catalogs/store/documentTypeStoreHelpers'
import { folderStoreActions } from '../../catalogs/store/folderStoreHelpers'
import { documentsData, documentsActions } from '../store/documentsHelpers'

export default {
  name: 'DocumentsTable',
  components: {
    DocumentSign,
    DocumentSigners,
    DocumentActionsMenu,
    DocumentStatus,
    OwnerAvatar,
    DocumentDocumentType,
    DocumentFolder,
    DocumentView
  },
  props: {
    search: { type: String },
    headers: { type: Array},
    folder: { type: Object },
    from: {
      type: String,
      default: 'documenttable'
    } 
  },
  data() {
    return {
      icon: {
        pdf: mdiFileOutline
      },
      options: {},
      loading: false,
    }
  },
  created() {
    Promise.all([this.getDocumentsType(), this.getFolders()])
      .catch(err => {
        this.notificationError(err)
      })
  },
  beforeDestroy() {
    this.clearDocumentInStorage()
  },
  computed: {
    ...documentsData
  },
  watch: {
    options: {
      handler () {
        this.loadData()
      }
    },
    search() {
      this.options.page = 1
      this.loadData(1)
      },
    folder(val, oldVal) {
      if(oldVal == null || val.idCarpeta != oldVal.idCarpeta) {
        this.loadData(1)
      }
    },
  },
  
  methods: {
    ...documentTypeStoreActions,
    ...folderStoreActions,
    ...documentsActions,
    loadData(page){
      let opt = {
        page: page || this.options.page,
        size: this.options.itemsPerPage
      }
      if (this.options.sortDesc.length > 0) {
        opt.order = this.options.sortDesc[0] ? 'DESC' : 'ASC'
      }
      if (this.options.sortBy.length > 0) {
        let hdr = this.documentsHeaders.find(h => h.value == this.options.sortBy[0])
        opt.sort = hdr.order ? hdr.order : hdr.value
      }
      if (this.search && this.search.length > 0) {
        opt.search = this.search
      }
      this.loading = true

      if (this.from == 'foldertable' && this.folder) {
        opt.idCarpeta = this.folder.idCarpeta

        this.getDocumentsByFolder(opt)
        .catch(err => {
          this.notificationError(err)
        })
        .finally(() => {
          this.loading = false
        })
      } else if(this.from == 'documenttable'){
        this.getDocuments(opt)
        .catch(err => {
          this.notificationError(err)
        })
        .finally(() => {
          this.loading = false
        })
      }
    },
    notificationError(msg) {
      pushNotification(
        this.$store,
        messageErrorResponse(msg) || this.msgDocumentServiceError,
        'error',
        'left',
        false,
        false
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.firmante {
  list-style: none;
}
.lista-firmantes {
  padding: 0px;
}
.constancia-label .registrado-label {
  font-size: 0.7rem;
}
</style>
